import React from "react";
import { Box } from "@mui/system";
import warning from "../../assets/images/warning.svg";
import { Typography } from "@mui/material";

interface formWarningProps {
  title: string;
  subTitle: string;
}

const FormWarning: React.FC<formWarningProps> = ({ title, subTitle }) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: { xs: "250px", sm: "250px", md: "321px", xl: "406px" },
          height: "fit-content",
          marginTop: "45px",
          background: "#FFF7E8 0% 0% no-repeat padding-box",
          border: "1px solid #FC912D4D",
          borderRadius: "10px",
          opacity: 1,
          marginLeft: { xs: "0px", sm: "10px", md: "10px", xl: "0px" },
        }}
      >
        <Box
          sx={{
            width: { xs: "28px", sm: "30px", md: "32px", xl: "37px" },
            height: { xs: "28px", sm: "30px", md: "32px", xl: "37px" },
            backgroundImage: `url(
                         ${warning}
                        )`,
            marginLeft: "15px",
            marginTop: "10px",
            backgroundSize: "cover",
          }}
        />
        <Box
          sx={{
            marginBottom: "10px",
            marginTop: "10px",
            marginLeft: "15px",
            marginRight: "5px",
          }}
        >
          <Typography
            sx={{
              letterSpacing: "0.16px",
              color: "#333333",
              opacity: 1,
              fontFamily: "Avenir",
              fontSize: { xs: "9px", sm: "11px", md: "13px", xl: "16px" },
              lineHeight: {
                xs: "16px",
                sm: "18px",
                md: "20px",
                xl: "25px",
              },
              fontWeight: 900,
              marginTop: "10px",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              letterSpacing: "0.16px",
              color: "#333333",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "9px", sm: "11px", md: "13px", xl: "16px" },
              lineHeight: {
                xs: "16px",
                sm: "18px",
                md: "20px",
                xl: "25px",
              },
              marginTop: "3px",
            }}
          >
            {subTitle}
          </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default FormWarning;
